module.exports = __webpack_public_path__ + "img/bank_24.8ea10d10.png";